import { ErrorTypes, createErrorWithType } from '../errorHandling';
import { DataProcessor } from './dataProcessor';
import { TEST_CONFIG } from '../testConstants';

export const QuestionProcessor = {
  groupByModule(questions) {
    return questions.reduce((acc, question) => {
      if (!acc[question.moduloId]) acc[question.moduloId] = [];
      acc[question.moduloId].push(question);
      return acc;
    }, {});
  },

  selectRandomQuestions(questions, amount) {
    if (!Array.isArray(questions) || questions.length === 0) {
      throw createErrorWithType(ErrorTypes.INVALID_INPUT, 'Lista de preguntas inválida');
    }

    const questionsByModule = this.groupByModule(questions);
    const modules = Object.keys(questionsByModule);
    const questionsPerModule = Math.floor(amount / modules.length);
    
    let selected = modules.flatMap(moduleId => {
      const available = questionsByModule[moduleId];
      const toSelect = Math.min(questionsPerModule, available.length);
      return DataProcessor.shuffleArray(available).slice(0, toSelect);
    });

    if (selected.length < amount) {
      const remaining = questions.filter(q => !selected.some(s => s.id === q.id));
      const additional = DataProcessor.shuffleArray(remaining).slice(0, amount - selected.length);
      selected = [...selected, ...additional];
    }

    return DataProcessor.shuffleArray(selected);
  }
};

export const ScoreCalculator = {
  calculate(answers, questions) {
    if (!questions?.length) {
      throw createErrorWithType(ErrorTypes.INVALID_INPUT, 'Lista de preguntas inválida');
    }

    const results = questions.reduce((acc, question, index) => {
      const answer = answers[index];
      if (!answer || answer.seleccionada === -1) acc.noContestadas++;
      else if (answer.seleccionada === question.respuestaCorrecta) acc.correctas++;
      else acc.incorrectas++;
      return acc;
    }, { correctas: 0, incorrectas: 0, noContestadas: 0 });

    const puntuacion = (results.correctas * TEST_CONFIG.SCORING.CORRECT) +
                      (results.incorrectas * TEST_CONFIG.SCORING.INCORRECT) +
                      (results.noContestadas * TEST_CONFIG.SCORING.UNANSWERED);

    return {
      ...results,
      puntuacion: Math.round(puntuacion * 10) / 10,
      aprobado: puntuacion >= TEST_CONFIG.PASSING_SCORE,
      total: questions.length
    };
  }
};